import type { ReactNode } from 'react';

export function Skeleton({ className = '' }: { className?: string }) {
  return <div aria-hidden="true" className={`skeleton rounded-xl ${className}`} />;
}

export function EmptyState({
  icon,
  title,
  children,
  action,
}: {
  icon: ReactNode;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center px-6 py-14 text-center">
      <div className="mb-5 grid size-16 place-items-center rounded-2xl bg-accent-soft text-accent" aria-hidden="true">
        {icon}
      </div>
      <h2 className="text-xl font-bold text-ink">{title}</h2>
      {children && <p className="mt-2 max-w-xs text-[0.95rem] text-muted">{children}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function Badge({ children, tone = 'neutral' }: { children: ReactNode; tone?: 'neutral' | 'accent' }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ${
        tone === 'accent' ? 'bg-accent-soft text-accent' : 'bg-surface-2 text-muted'
      }`}
    >
      {children}
    </span>
  );
}

export function Avatar({ label, className = '' }: { label: string; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`grid size-10 shrink-0 place-items-center rounded-full bg-surface-3 text-sm font-bold text-ink ${className}`}
    >
      {label}
    </span>
  );
}
